import { CssBaseline, ThemeProvider } from '@mui/material'
import AppNavigator from './AppNavigator'
import { AppDefaultTheme } from '../themes/AppDefaultTheme'
import '@fontsource/bebas-neue'
import '../config/firebase.config'

const AppWrapper = (props) => {
  if (
    window.location.host === "personal-architect-neighborly.web.app" ||
    window.location.host === "personal-architect-neighborly.firebaseapp.com"
  ) {
    window.location.href = "https://neighborly.personalarch.com"
  }

  return (
    <ThemeProvider theme={AppDefaultTheme}>
      <AppNavigator />
      <CssBaseline />
    </ThemeProvider>
  )
}

export default AppWrapper